import { render } from "./agent_list.vue?vue&type=template&id=4372c38d"
import script from "./agent_list.vue?vue&type=script&lang=js"
export * from "./agent_list.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__